import React from 'react';

import BasePage from './BasePage';
import withCookieHeaderHeight from '../components/withCookieHeaderHeight';
import ConnectedCityBrowseBaseScreen from '../SearchApp/containers/ConnectedCityBrowseBaseScreen';
import {HEADER_HEIGHT} from '../SearchApp/constants';

import './BrowsePage.scss';

class BrowsePage extends React.Component {
    render() {
        return (
            <BasePage {...this.props}>
                <div className="feed-browse-page" style={{paddingTop: this.props.cookieHeaderHeight + HEADER_HEIGHT}}>
                    <ConnectedCityBrowseBaseScreen {...this.props} />
                </div>
            </BasePage>
        );
    }
}

export default withCookieHeaderHeight(BrowsePage);
